<template>
	<div class="clearfix" style="min-height: 77px; position: relative;">
		<div style="left: -28px; float: left">
			<template v-if="settings.ready">
				<apexchart :options="options" :series="series" v-if="series.reduce((a, b) => a + b, 0) > 0"></apexchart>
				<apexchart :options="Object.assign({}, options , {labels:[$t('no-data')], colors:['#e5e7eb'], dataLabels:{enabled: false}})" :series="[1]" v-else></apexchart>
			</template>
			<template v-else>
				<div class="skeleton muted" style="border-radius: 88px; width: 80px; height: 80px; margin: 4px; background-color: #E5E7EB"></div>
			</template>
		</div>
		<p class="pt-2 font-bold" style="position: absolute; left: 119px; top: 6px;">{{ settings.caption }}</p>
	</div>
</template>

<script>
export default {
	props: {
		settings: Object
	},
	data() {
		return {

		}
	},
	mounted() {
	},
	computed: {
		series: function(){
			var series = [];
			if(this.settings.ready){
				if(this.settings.data.length){
					this.settings.data.forEach(item => {
						series.push(item.value);
					});
				}
			}
			return series;
		},
		colors: function(){
			//			  Green		 Yellow		Amber	   Red		  Blue		 Purple		Teal	   Brown
			var colors = ["#4ade80", "#facc15", "#fb923c", "#ef4444", "#3b82f6", "#cf66e6", "#7fd7d1", "#956b46"];

			var color = '';
			var i = 0;
			for (i in this.settings.data) {
				if('color' in this.settings.data[i] && this.settings.data[i].color){
					color = this.settings.data[i].color;
					switch(color) {
						case 'green':
							color = "#4ade80";
							break;
						case 'yellow':
							color = "#facc15";
							break;
						case 'amber':
							color = "#fb923c";
							break;
						case 'red':
							color = "#ef4444";
							break;
						case 'blue':
							color = "#3b82f6";
							break;
						case 'purple':
							color = "#cf66e6";
							break;
						case 'teal':
							color = "#7fd7d1";
							break;
						case 'brown':
							color = "#956b46";
							break;
						default:
							break;
					}
					colors[i] = color;
				}
			}

			if('colors' in this.settings){
				colors = [];
				for (i in this.settings.colors) {
					color = this.settings.colors[i];
					switch(color) {
						case 'green':
							color = "#4ade80";
							break;
						case 'yellow':
							color = "#facc15";
							break;
						case 'amber':
							color = "#fb923c";
							break;
						case 'red':
							color = "#ef4444";
							break;
						case 'blue':
							color = "#3b82f6";
							break;
						case 'purple':
							color = "#cf66e6";
							break;
						case 'teal':
							color = "#7fd7d1";
							break;
						case 'brown':
							color = "#956b46";
							break;
						default:
							break;
					}
					colors.push(color);
				}
			}

			return colors;
		},
		labels: function(){
			var labels = []
			this.settings.data.forEach(item => {
				labels.push(item.caption);
			});
			return labels;
		},
		type: function(){
			if('style' in this.settings){
				if(this.settings.style == 'pie'){
					return 'pie';
				}
			}
			return 'donut';
		},
		options: function(){
			return {
				chart: {
					width: 200,
					type: this.type
				},
				labels: this.labels,
				dataLabels: {
					enabled: true,
					style: {
						fontSize: '10px',
						fontFamily: 'Helvetica, Arial, sans-serif',
						fontWeight: 'bold',
						colors: ['#FFF']
					}
				},
				colors: this.colors,
				legend: {
					show: false
				},
				responsive: [
					{
						breakpoint: 99999,
						options: {
							chart: {
								width: 138,
							},
							legend: {
								position: "bottom",
							},
						},
					},
					{
						breakpoint: 480,
						options: {
							chart: {
								width: 138,
							},
							legend: {
								position: "bottom",
							},
						},
					},
				],
				plotOptions: {
					pie: {
						donut: {
							size: '72%'
						},
					}
				},
				stroke: {
					show: false
				}
			}
		}
	}
};
</script>
